// data.ts
// import { ACCEPTED_FILE_TYPES } from './schema'
export const ContactInformation = [
  {
    name: 'startup_name',
    label: 'Startup/Company name',
    type: 'text',
    required: true,
    disabled: true,
  },
  // {
  //   name: 'legal_entity_type',
  //   label: 'Legal entity type',
  //   type: 'custom_select',
  //   required: true,
  //   disabled: true,
  //   // (e.g., Sole Proprietorship, Partnership, Private Limited Company, LLP, etc.)

  // },
  {
    name: 'legal_entity_type' as const,
    label: 'Legal entity type',
    type: 'custom_select' as const,
    placeholder: 'Select Legal Entity Type',
    required: true,
    disabled: true,
    desc: 'name',
    descId: 'id',
    id: 'legal_entity_type',
    data: [
      { name: 'Sole Proprietorship', id: '1' },
      { name: 'Partnership', id: '2' },
      { name: 'Private Limited Company', id: '3' },
      { name: 'LLP', id: '4' },
    ],
  },
  {
    name: 'registration_date',
    label: 'Date of registration/incorporation',
    type: 'date',
    required: true,
    disabled: true,
  },
  { name: 'website', label: 'Website', type: 'text', disabled: true },
  // {
  //   name: 'startup_phone',
  //   label: 'Phone number',
  //   type: 'text',
  //   disabled: true,
  // },
]
//
export const personalInformation = [
  {
    name: 'contact_name',
    label: 'Full name',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'contact_designation',
    label: 'Designation',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'contact_email',
    label: 'Email address',
    type: 'email',
    required: true,
    disabled: true,
  },
  {
    name: 'contact_phone',
    label: 'Phone number',
    type: 'text',
    required: true,
    disabled: true,
  },
]

export const addressInformation = [
  {
    name: 'address_street',
    label: 'Street address',
    type: 'textarea',
    required: true,
    disabled: true,
  },
  {
    name: 'address_city',
    label: 'City',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'address_state',
    label: 'State/Province',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'address_zip',
    label: 'PIN/Zip Code',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'address_country',
    label: 'Country',
    type: 'text',
    required: true,
    defaultValue: 'India',
    disabled: true,
  },
]

export const aboutStartup = [
  // {
  //   name: 'industry_sector',
  //   label: 'Sector/Industry',
  //   type: 'text',
  //   required: true,
  //   disabled: true,
  // },

  // o	Industry Sector: (e.g., Technology, Healthcare, Education, E-commerce, Agri-tech, Fintech, etc.) (Descriptive type)

  {
    name: 'industry_sector' as const,
    label: 'Sector/Industry',
    type: 'custom_select' as const,
    placeholder: 'Select Sector/Industry',
    required: true,
    disabled: true,
    desc: 'name',
    descId: 'id',
    id: 'industry_sector',
    data: [
      { name: 'Technology', id: '1' },
      { name: 'Healthcare', id: '2' },
      { name: 'Education', id: '3' },
      { name: 'E-commerce', id: '4' },
      { name: 'Agri-tech', id: '5' },
      { name: 'Fintech', id: '6' },
    ],
  },

  // {
  //   name: 'team_size',
  //   label: 'Team Size',
  //   type: 'text',
  //   required: true,
  //   disabled: true,
  // },
  {
    name: 'startup_stage',
    label: 'Startup Stage',
    type: 'text',
    required: true,
    disabled: true,
  },
  //   o	Idea Stage
  // o	Prototype/MVP Developed
  // o	Pre-Revenue
  // o	Generating Revenue
  // o	Scaling Up

  {
    name: 'business_description',
    label: 'Brief Description of your Startup/Business Idea',
    type: 'textarea',
    required: true,
    disabled: true,
  },
]

export const incubationNeeds = [
  {
    name: 'annual_turnover',
    label: 'Annual Turnover',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'problem_statement',
    label: 'Preferred Incubation Duration',
    type: 'text',
    required: true,
    disabled: true,
  },
  {
    name: 'additional_comments',
    label: 'Any Additional Comments',
    type: 'text',
    required: false,
    disabled: true,
  },
  {
    name: 'solution',
    label: 'solution',
    type: 'text',
    required: false,
    disabled: true,
  },
  {
    name: 'unique_value_proposition',
    label: 'Unique Value Proposition',
    type: 'text',
    required: false,
    disabled: true,
  },
  {
    name: 'target_market',
    label: 'Target Market',
    type: 'text',
    required: false,
    disabled: true,
  },
  {
    name: 'revenue_model',
    label: 'Revenue Model',
    type: 'text',
    required: false,
    disabled: true,
  },
  {
    name: 'service_interest',
    label: 'Service Interest',
    type: 'text',
    required: false,
    disabled: true,
  },

  {
    name: 'previous_programs',
    label: 'Previous Programs',
    type: 'text',
    required: false,
    disabled: true,
  },
  {
    name: 'declaration_agreed',
    label: 'Declaration',
    type: 'radio',
    required: true, // Changed to true since it's required
    data: [
      { id: 1, radioLabel: 'Yes', value: 1 }, // Use actual boolean strings
      { id: 2, radioLabel: 'No', value: 0 },
    ],
    disabled: true,
  },

  // {
  //   name: 'signature',
  //   required: false,
  //   id: 'attachment',
  //   selectedFiles: [],
  //   descId: 'id',
  //   supportedExtensions: ACCEPTED_FILE_TYPES,
  //   supportedFiles: ACCEPTED_FILE_TYPES,
  //   acceptedFiles: 'upload .jpeg, .jpg, .png files',
  //   type: 'file_upload',
  //   value: null, // Initialize as null or with existing file data
  //   needConfirmation: true,
  //   disabled: true,
  // },
]
